import(/* webpackMode: "eager" */ "D:\\BDT apps\\website_bdt\\website-template\\node_modules\\next\\dist\\client\\app-dir\\link.js");
